export default "__VITE_ASSET__msBShwZc__"